"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertiesSchema = exports.dataSchema = void 0;
var yup = __importStar(require("yup"));
var schemaUtils_1 = require("../../core/schemaUtils");
var Input_schema_1 = require("../../core/Input.schema");
var BaseTextInput_schema_1 = require("../../core/BaseTextInput.schema");
exports.dataSchema = schemaUtils_1.createDataSchema('TextInput', yup
    .object({
    textType: yup.mixed().default('text'),
    maxLength: yup.number().notRequired(),
    min: yup.number().notRequired(),
    max: yup.number().notRequired(),
    step: yup.number().notRequired(),
    pattern: yup.string().notRequired(),
    label: yup.string().notRequired(),
    placeholder: yup.string().notRequired(),
    prefix: yup.string().notRequired(),
    phoneFormat: yup.string().notRequired(),
})
    .concat(BaseTextInput_schema_1.baseTextInput));
exports.propertiesSchema = schemaUtils_1.createPropertiesSchema('TextInputProperties', yup
    .object({
    textAlignment: yup.mixed().default('left'),
    textPadding: yup.number().default(3),
    placeholder: yup.string().notRequired(),
    defaultTextType: yup.mixed(),
    autoComplete: yup.boolean().default(false),
})
    .concat(Input_schema_1.inputPropertiesSchema));
//# sourceMappingURL=TextInput.schema.js.map